function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs112"
}, /*#__PURE__*/React.createElement("style", {
  type: "text/css",
  id: "style10"
}, "\n    .fil0 {fill:#1A1A1A}\n    .fil1 {fill:#666666}\n  "));

var _ref3 = /*#__PURE__*/React.createElement("metadata", {
  id: "CorelCorpID_0Corel-Layer"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "fil0",
  d: "m 7250.02,29424.93 c 458.07,-500 2185.21,-1284.62 3011.63,-1442.5 C 9977.02,27611.19 9184.48,26632.17 8816.89,26316.41 8600.4,24024.26 7660.4,2597.93 7250.02,499.31 6839.63,2597.93 5899.63,24024.26 5683.14,26316.41 c -367.59,315.76 -1160.12,1294.78 -1444.76,1666.02 828.05,156.24 2571,924.93 3011.64,1442.5 z m 0,-23544.66 c -280.12,1648.83 -500.62,19078.6 -667.04,20840.87 -296.43,254.65 -574.29,521.96 -819.89,810.49 550.69,152.1 1053.45,340.73 1488.93,557.35 435.49,-216.62 935.61,-397.09 1486.31,-549.19 -245.61,-288.53 -523.46,-555.85 -819.9,-810.49 C 7752.02,24967.02 7530.13,7529.1 7250.02,5880.27 Z",
  id: "path15"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "fil1",
  d: "m 7250.02,4281.14 c 410.38,2098.62 720.5,20028.14 936.98,22320.28 367.6,315.76 706.57,651.09 991.21,1022.32 -748.36,206.7 -1401.09,467.87 -1928.19,799.07 -527.11,-331.2 -1179.83,-592.37 -1928.19,-799.07 284.63,-371.23 623.61,-706.56 991.2,-1022.32 216.49,-2292.14 526.6,-20221.66 936.99,-22320.28 z m 0,-2665.63 c 410.38,2098.62 1062.11,22570.4 1278.6,24862.54 367.59,315.76 867.33,915.4 1151.97,1286.63 -748.36,206.7 -1903.47,742.84 -2430.57,1074.04 -527.11,-331.2 -1682.21,-867.34 -2430.57,-1074.04 284.63,-371.23 784.38,-970.87 1151.97,-1286.63 216.49,-2292.14 868.21,-22763.92 1278.6,-24862.54 z",
  id: "path17"
});

function SvgLargeArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg118",
    viewBox: "0 0 289.25619 60.232701",
    height: "60.2327mm",
    width: "289.2562mm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-147.16952,49.01516)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    id: "Camada_x0020_1",
    transform: "matrix(0,0.01,-0.01,0,441.41882,-91.39896)"
  }, _ref3, _ref4, _ref5)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeArrow);
export default __webpack_public_path__ + "static/media/largeArrow.933774e3.svg";
export { ForwardRef as ReactComponent };